import React, { useEffect, useState } from "react";
import regbanner from "../../../assets/icons/verificationInProgress.png";
import "./DocsVerificationInProgress.scss";
import { decryptJwtToken } from "../../Services/dashboard/encryptionNew";
import { ITokenObj } from "../../types/genericTypes";
import GlobalStore from "../../store/globalStore";
import successTick from "../../../assets/icons/finalTick.svg";
import { AGetStageCompletionStatus } from "../../Services/registration/continueApiService";

const DocsVerificationInProgress: React.FC = () => {
  const clientPartialDetails_ao = JSON.parse(
    window.localStorage.getItem("clientPartialDetails_ao") || "{}"
  );

  const applicationId =
    GlobalStore?.applicationID || clientPartialDetails_ao?.applicationId || "";
  const [accountCagtegory, setAccountCagtegory] = useState(0)

  const showMessage = (): boolean => {
    let userId = "0";
    let accountcategory = "0";

    const tokenObj: string = decryptJwtToken(
      GlobalStore?.token && GlobalStore?.token !== ""
        ? GlobalStore?.token
        : clientPartialDetails_ao?.token
    );

    if (tokenObj) {
      const tokenMainObj: ITokenObj = JSON.parse(tokenObj);
      userId = tokenMainObj?.UserId?.toString();
      accountcategory = tokenMainObj?.AccountCategory?.toString();
    }

    return userId !== "0" && accountcategory === "2";
  };

  const getClientStageDetails = (res: any) => {
    if (!res || res.error) return;

    if (res.data) {
      const responseObj = JSON.parse(res.data);
      console.log("Stage completion response:", responseObj);
      setAccountCagtegory(responseObj?.accountcategory)
    }
  };

  useEffect(() => {
    if (applicationId) {
      AGetStageCompletionStatus(getClientStageDetails, applicationId);
    }
  }, [applicationId]);

  return (
    <>
      {accountCagtegory !== 2 ? (
        <div className="docs-pending-root" role="status" aria-live="polite" aria-atomic="true">
          <img src={regbanner} className="verified-img" alt="Verification" />

          <div>
            <h2 className="status-heading">
              Document Verification in Process
            </h2>

            <span className="status-subHead">
              {showMessage() ? (
                <>
                  The documents have been successfully received for quality
                  check. This process may take up to 45 minutes. You can track
                  the customer journey on One Platform in Order Book.
                </>
              ) : (
                <>
                  Your documents are getting verified by our agents.
                  <br />
                  This process usually takes 1–2 business days.
                </>
              )}
            </span>

            {!showMessage() && (
              <div className="notes">
                We will notify you of the update via{" "}
                <span className="email-text">WhatsApp/Email</span>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="application-submitted-root" role="status" aria-live="polite" aria-atomic="true">
          <div className="success-icon">
            <img src={successTick} alt="Success" />
          </div>

          <h2 className="title">Application Submitted</h2>

          <p className="description">
            Investment Account Application
            {applicationId && <strong> ({applicationId})</strong>} has been
            submitted and is under Quality Screening. Post approval, the customer
            will receive an authentication message to authorize and finalize the
            account.
          </p>

          <div className="help-section">
            <h3>Need help?</h3>

            <p className="help-text">
              You can monitor your application status anytime through
              <br />
              <strong>One Platform → Account Opening Order Book</strong>
            </p>

            <p className="contact">Reach out to our customer care team</p>

            <div className="contact-details">
              <span>📞 1800-102-3335</span>
              <span>✉ helpdesk@nuvama.com</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DocsVerificationInProgress;
